<script>
import { h } from "vue";
import { isInternalUrl, tokenize } from "@/utils/richText";

// Renders notification text with links as real nodes (no v-html). Emits "link" with the URL.
export default {
  name: "ComponentRichText",
  props: { text: { type: String, default: "" } },
  emits: ["link"],
  render() {
    return h(
      "span",
      { class: "rich" },
      tokenize(this.text).map((p) =>
        p.url
          ? h(
              "a",
              {
                href: p.url,
                class: "rich-link",
                ...(isInternalUrl(p.url) ? {} : { target: "_blank", rel: "noopener noreferrer" }),
                onClick: (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.$emit("link", p.url);
                },
              },
              p.text
            )
          : p.text
      )
    );
  },
};
</script>

<style scoped>
.rich { white-space: pre-line; overflow-wrap: break-word; }
.rich-link { color: #1a8ea8; font-weight: 600; text-decoration: underline; }
</style>
